import { render, staticRenderFns } from "./Oneclick-terms.vue?vue&type=template&id=1c8180e3&scoped=true&"
import script from "./Oneclick-terms.vue?vue&type=script&lang=js&"
export * from "./Oneclick-terms.vue?vue&type=script&lang=js&"
import style0 from "./Oneclick-terms.vue?vue&type=style&index=0&id=1c8180e3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8180e3",
  null
  
)

export default component.exports